import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { isOnlySpecificKeyInObjTrue } from '@utils/globalConstant';

export const FocusFirstError = () => {
  const { submitCount, errors } = useFormikContext();
  const [submit, setSubmit] = useState(0);

  useEffect(() => {
    if (submitCount > 0 && submitCount !== submit && Object.keys(errors).length > 0) {
      setSubmit(submitCount);
    
      // Handle specific cscPassword field case
      const specificKey = 'match';
      const isSpecificKeyValid = isOnlySpecificKeyInObjTrue(errors.otherErrors, specificKey);

      if (!isSpecificKeyValid) {
        const cscPasswordElement = document.querySelector(`[name="cscPassword"]`);
        if (cscPasswordElement) {
          cscPasswordElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          cscPasswordElement.focus({ preventScroll: true });
          return; // Prevent focusing on other fields
        }
      }

      const firstErrorField = Object.keys(errors)[0];
      let errorElement = document.querySelector(`[name="${firstErrorField}"]`);
      if (firstErrorField === 'birthDate') {
        const birthDateElement = document.querySelector('.duet-date__input');
        if (birthDateElement) {
          errorElement = birthDateElement;
        }
      }
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        errorElement.focus({ preventScroll: true });
      }
    }
  }, [submitCount, errors]);

  return null;
};